import { KeyRound } from "lucide-react";
import { useEffect, useState } from "react";
import { IdentityStatus } from "../components/IdentityShell.tsx";
import { auth, runOnce, safeReturnTo } from "../lib/auth-client.ts";

export function Callback() {
  const [message, setMessage] = useState("正在验证登录结果…");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    const code = new URLSearchParams(window.location.search).get("code");
    if (!code) {
      setMessage("登录结果不完整，请返回重新登录。");
      setFailed(true);
      return;
    }
    const operationKey = `auth-callback:${window.location.href}`;
    void runOnce(operationKey, async () => {
      const { error } = await auth.exchangeCodeForSession(code);
      if (error) throw error;
      const returnTo = safeReturnTo(sessionStorage.getItem("matrix-auth-return-to"));
      sessionStorage.removeItem("matrix-auth-return-to");
      return returnTo;
    })
      .then((returnTo) => {
        if (active) window.location.replace(returnTo);
      })
      .catch(() => {
        if (active) {
          setMessage("无法完成登录验证，请返回重新登录。");
          setFailed(true);
        }
      });
    return () => {
      active = false;
    };
  }, []);

  if (failed) {
    return (
      <IdentityStatus
        title="登录失败"
        message={message}
        variant="failed"
        step="回调"
        status="需要处理"
        action={{
          label: "重新登录",
          icon: <KeyRound size={17} />,
          onClick: () => window.location.replace("/")
        }}
      />
    );
  }

  return (
    <IdentityStatus
      title="正在完成登录"
      message={message}
      step="回调"
      status="验证中"
    />
  );
}
